import React from 'react';
import { ThemeProvider } from '@emotion/react';
import { useTheme } from '../utils/theme.js';
import { MainContainerWrapper, ContainerWrapper } from './styles/index.js';
const ContainerFromThemeData = ({ themeData, className, children }) => {
    const theme = useTheme(themeData);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(MainContainerWrapper, { className: className }, children)));
};
const Container = ({ themeData, className, theme, children, }) => {
    if (!themeData) {
        return (React.createElement(ContainerWrapper, { className: className, theme: theme }, children));
    }
    return (React.createElement(ContainerFromThemeData, { themeData: themeData, className: className }, children));
};
export default Container;
